import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import AdminDataTable from "../../components/common/AdminDataTable";
import MemberLoginHistoryFilter from "./MemberLoginHistoryFilter";
import { memberLoginHistoryColumns } from "../../tables/memberLoginHistoryColumns";

export default function MemberLoginHistory() {
  const PAGE_SIZE = 10;
  const { profile_id: urlProfileId } = useParams();

  const [sortBy, setSortBy] = useState("login_time");
  const [sortOrder, setSortOrder] = useState("desc");
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const token = localStorage.getItem("adminToken");
  const [loginHistory, setLoginHistory] = useState([]);
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    profile_id: urlProfileId || "",
    device_type: "",
    login_status: "",
    search: "",
  });

  const API_URL = process.env.REACT_APP_BASE_URL_API || "";

  // Fetch login history data
  const fetchLoginHistory = async (pageIndex = 0, appliedFilters = filters) => {
    setListLoading(true);
    try {
      const pageNumber = pageIndex + 1;

      // Build query params
      const queryParams = new URLSearchParams({
        page: pageNumber,
        limit: pageSize,
      });

      // Add filters only if they have values
      if (appliedFilters.profile_id) {
        queryParams.append("profile_id", appliedFilters.profile_id);
      }
      if (appliedFilters.from_date) {
        queryParams.append("from_date", appliedFilters.from_date);
      }
      if (appliedFilters.to_date) {
        queryParams.append("to_date", appliedFilters.to_date);
      }
     
      if (appliedFilters.device_type) {
        queryParams.append("device_type", appliedFilters.device_type);
      }
      if (appliedFilters.login_status) {
        queryParams.append("login_status", appliedFilters.login_status);
      }
      if (appliedFilters.search) {
        queryParams.append("search", appliedFilters.search);
      }

      const url = `${API_URL}/api/admin/user-login-history?${queryParams.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch login history");
      }

      const data = await response.json();

      if (data.status) {
        setLoginHistory(data.data.records || []);
        setTotalPages(data.data.pagination.total_pages || 1);
        setTotalRecords(data.data.pagination.total_records || 0);
        setPage(pageNumber);
      } else {
        console.error("API Error:", data.message);
        setLoginHistory([]);
        setTotalPages(1);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching login history:", error);
      setLoginHistory([]);
      setTotalPages(1);
      setTotalRecords(0);
    } finally {
      setListLoading(false);
    }
  };

  // Initialize filters with URL profile_id if available
  useEffect(() => {
    if (urlProfileId) {
      const newFilters = {
        ...filters,
        profile_id: urlProfileId,
      };
      setFilters(newFilters);
      fetchLoginHistory(0, newFilters);
    } else {
      fetchLoginHistory(0, filters);
    }
  }, [urlProfileId]);

  // Fetch on page/size change
  useEffect(() => {
    if (page > 1 || pageSize !== PAGE_SIZE) {
      fetchLoginHistory(page - 1, filters);
    }
  }, [page, pageSize]);

  // Handle filter changes
  const handleFilter = (newFilters) => {
    setFilters(newFilters);
    setPage(1);
    fetchLoginHistory(0, newFilters);
  };

  // Handle sort
  const handleSort = (column) => {
    if (!column) return;
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const columns = memberLoginHistoryColumns();

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Member Login History" />

        {/* Main Content */}
        <div className="right_col" role="main">
          {/* Page Title */}
         

          {/* Body Card */}
          <div className="x_panel">
            <div className="x_title">
              <h2>Login Activity -  Total Records: <strong>( {totalRecords} )</strong></h2>
              <ul className="nav navbar-right panel_toolbox">
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>
              </ul>
              <div className="clearfix" />
            </div>

            <div className="x_content">
              <div className="row">
                <div className="col-sm-12">
                  {/* Filter Section */}
                  <MemberLoginHistoryFilter 
                    onFilter={handleFilter} 
                    initialProfileId={urlProfileId || ""}
                  />

                  {/* Data Table */}
                  <AdminDataTable
                    columns={columns}
                    data={loginHistory}
                    page={page}
                    pageSize={pageSize}
                    totalPages={totalPages}
                    loading={listLoading}
                    onPageChange={setPage}
                    onPageSizeChange={(size) => {
                      setPageSize(size);
                      setPage(1);
                    }}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    onSort={handleSort}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* End Body Card */}
        </div>

        <Footer />
      </div>
    </div>
  );
}
